import React from "react";
import SingleProject from "./SingleProject";
import t_1 from "../assets/images/t_1 (1).png";
import f_1 from "../assets/images/f_1.png";
import k_1 from "../assets/images/k_1-min.png";

const AllProject = () => {
  return (
    <div
      data-aos="fade-up"
      data-aos-duration="3000"
      className="grid grid-cols-1 md:grid-cols-2 mx-auto w-full md:gap-5 lg:grid-cols-2 lg:gap-5"
    >
      <SingleProject
        img={t_1}
        des={"Developed with react.js, Node.js, firebase , payment system etc"}
        name={"Mr.tools"}
        link={"Mr.tools"}
      />
      <SingleProject
        img={f_1}
        des={"Created using CRUD operation, react.js, Node.js, firebase etc"}
        link={"fruitShop"}
        name={"Fruit shop"}
      />
      <SingleProject
        img={k_1}
        des={
          "Designed created Bootstrap, react-webpack, react.js, Node.js, firebase etc"
        }
        link={"khPhotography"}
        name={"K.H Photography"}
      />
    </div>
  );
};

export default AllProject;
